import React, { useState, useEffect, useContext } from "react";
import {
  makeStyles,
  Paper,
  Grid,
  FormControl,
  InputLabel,
  MenuItem,
  TextField,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  IconButton,
  Select,
  Button,
} from "@material-ui/core";
import { Formik, Form, Field } from "formik";
import ButtonWithSpinner from "../ButtonWithSpinner";
import ConfirmationModal from "../ConfirmationModal";

import { Edit as EditIcon } from "@material-ui/icons";

import { toast } from "react-toastify";
import useCompanies from "../../hooks/useCompanies";
import usePlans from "../../hooks/usePlans";
import ModalUsers from "../ModalUsers";
import api from "../../services/api";
import { head, isArray, has } from "lodash";
import { useDate } from "../../hooks/useDate";
import ColorModeContext from "../../layout/themeContext";

import moment from "moment";
import { i18n } from "../../translate/i18n";
import { useTheme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    padding: "2px"
  },
  mainPaper: {
    width: "100%",
    flex: 1,
    // padding: theme.spacing(2), //comentado para retirar o scroll do Empresas
  },
  fullWidth: {
    width: "100%",
  },
  tableContainer: {
    width: "100%",
    overflowX: "auto",
    ...theme.scrollbarStyles,
    padding: "2px",
    marginTop: theme.spacing(1.5),
    borderRadius: 8,
  },
  secondaryText: {
    display: "block",
    fontSize: 11,
    opacity: 0.78,
    marginTop: 2,
    whiteSpace: "nowrap",
  },
  sectionPaper: {
    width: "100%",
    padding: theme.spacing(2),
    borderRadius: 8,
  },
  sectionTitle: {
    fontSize: 15,
    fontWeight: 600,
    marginBottom: theme.spacing(1),
  },
  sectionDescription: {
    fontSize: 12,
    opacity: 0.75,
    marginTop: -4,
    marginBottom: theme.spacing(1),
  },
  textfield: {
    width: "100%",
  },
  textRight: {
    textAlign: "right",
  },
  row: {
    // paddingTop: theme.spacing(2),
    // paddingBottom: theme.spacing(2),
  },
  control: {
    // paddingRight: theme.spacing(1),
    // paddingLeft: theme.spacing(1),
  },
  buttonContainer: {
    textAlign: "right",
    // padding: theme.spacing(1),
  },
}));

const EXTRA_FEATURES = [
  { key: "useWhatsapp", label: "WhatsApp" },
  { key: "useWhatsappOfficial", label: "WhatsApp Oficial" },
  { key: "useFacebook", label: "Facebook" },
  { key: "useInstagram", label: "Instagram" },
  { key: "useCampaigns", label: "Campanhas" },
  { key: "useSchedules", label: "Agendamentos" },
  { key: "useInternalChat", label: "Chat interno" },
  { key: "useExternalApi", label: "API externa" },
  { key: "useKanban", label: "Kanban" },
  { key: "useOpenAi", label: "Talk.AI" },
  { key: "useIntegrations", label: "Integrações" },
  { key: "wavoip", label: "Wavoip" }
];

export function CompanyForm(props) {
  const { onSubmit, onDelete, onCancel, initialValue, loading } = props;
  const classes = useStyles();
  const [plans, setPlans] = useState([]);
  const [modalUser, setModalUser] = useState(false);
  const [firstUser, setFirstUser] = useState({});

  const [record, setRecord] = useState({
    name: "",
    email: "",
    phone: "",
    planId: "",
    storageExtraGB: 0,
    featureOverrides: {},
    status: true,
    // campaignsEnabled: false,
    dueDate: "",
    recurrence: "",
    password: "",
    generateInvoice: true,
    ...initialValue,
  });

  const { list: listPlans } = usePlans();

  useEffect(() => {
    async function fetchData() {
      const list = await listPlans();
      setPlans(list);
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setRecord((prev) => {
      if (moment(initialValue).isValid()) {
        initialValue.dueDate = moment(initialValue.dueDate).format(
          "YYYY-MM-DD"
        );
      }
      return {
        ...prev,
        ...initialValue,
      };
    });
  }, [initialValue]);

  const handleSubmit = async (data) => {
    if (data.dueDate === "" || moment(data.dueDate).isValid() === false) {
      data.dueDate = null;
    }
    console.log("Dados do formulário:", data);
    onSubmit(data);
    setRecord({ ...initialValue, dueDate: "", generateInvoice: true });
  };

  const handleOpenModalUsers = async () => {
    try {
      const { data } = await api.get("/users/list", {
        params: {
          companyId: initialValue.id,
        },
      });
      if (isArray(data) && data.length) {
        setFirstUser(head(data));
      }
      setModalUser(true);
    } catch (e) {
      toast.error(e);
    }
  };

  const handleCloseModalUsers = () => {
    setFirstUser({});
    setModalUser(false);
  };

  const incrementDueDate = () => {
    const data = { ...record };
    if (data.dueDate !== "" && data.dueDate !== null) {
      switch (data.recurrence) {
        case "MENSAL":
          data.dueDate = moment(data.dueDate)
            .add(1, "month")
            .format("YYYY-MM-DD");
          break;
        case "BIMESTRAL":
          data.dueDate = moment(data.dueDate)
            .add(2, "month")
            .format("YYYY-MM-DD");
          break;
        case "TRIMESTRAL":
          data.dueDate = moment(data.dueDate)
            .add(3, "month")
            .format("YYYY-MM-DD");
          break;
        case "SEMESTRAL":
          data.dueDate = moment(data.dueDate)
            .add(6, "month")
            .format("YYYY-MM-DD");
          break;
        case "ANUAL":
          data.dueDate = moment(data.dueDate)
            .add(12, "month")
            .format("YYYY-MM-DD");
          break;
        default:
          break;
      }
    }
    setRecord(data);
  };

  return (
    <>
      <ModalUsers
        userId={firstUser.id}
        companyId={initialValue.id}
        open={modalUser}
        onClose={handleCloseModalUsers}
      />
      <Formik
        enableReinitialize
        className={classes.fullWidth}
        initialValues={record}
        onSubmit={(values, { resetForm }) =>
          setTimeout(() => {
            handleSubmit(values);
            resetForm();
          }, 500)
        }
      >
        {(values, setValues) => (
          <Form className={classes.fullWidth}>
            <Grid spacing={1} justifyContent="center" container>

              {/* DADOS DA EMPRESA */}
              <Grid xs={12} item>
                <Paper variant="outlined" className={classes.sectionPaper}>
                  <div className={classes.sectionTitle}>
                    Dados da empresa
                  </div>

                  <Grid container spacing={1}>
                    <Grid xs={12} sm={6} md={3} item>
                      <Field
                        as={TextField}
                        label={i18n.t("compaies.table.name")}
                        name="name"
                        variant="outlined"
                        className={classes.fullWidth}
                        margin="dense"
                      />
                    </Grid>

                    <Grid xs={12} sm={6} md={3} item>
                      <Field
                        as={TextField}
                        label={i18n.t("compaies.table.email")}
                        name="email"
                        variant="outlined"
                        className={classes.fullWidth}
                        margin="dense"
                        required
                      />
                    </Grid>

                    <Grid xs={12} sm={6} md={2} item>
                      <Field
                        as={TextField}
                        label={i18n.t("compaies.table.password")}
                        name="password"
                        type="password"
                        variant="outlined"
                        className={classes.fullWidth}
                        margin="dense"
                      />
                    </Grid>

                    <Grid xs={12} sm={6} md={2} item>
                      <Field
                        as={TextField}
                        label={i18n.t("compaies.table.phone")}
                        name="phone"
                        variant="outlined"
                        className={classes.fullWidth}
                        margin="dense"
                      />
                    </Grid>

                    <Grid xs={12} sm={6} md={2} item>
                      <Field
                        as={TextField}
                        label={i18n.t("compaies.table.document")}
                        name="document"
                        variant="outlined"
                        className={classes.fullWidth}
                        margin="dense"
                      />
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>

              {/* PLANO E COBRANCA */}
              <Grid xs={12} item>
                <Paper variant="outlined" className={classes.sectionPaper}>
                  <div className={classes.sectionTitle}>
                    Plano e cobrança
                  </div>

                  <Grid container spacing={1}>
                    <Grid xs={12} sm={6} md={3} item>
                      <FormControl margin="dense" variant="outlined" fullWidth>
                        <InputLabel htmlFor="plan-selection">
                          {i18n.t("compaies.table.plan")}
                        </InputLabel>

                        <Field
                          as={Select}
                          id="plan-selection"
                          label={i18n.t("compaies.table.plan")}
                          labelId="plan-selection-label"
                          name="planId"
                          margin="dense"
                          required
                        >
                          {plans.map((plan, key) => (
                            <MenuItem key={key} value={plan.id}>
                              {plan.name}
                            </MenuItem>
                          ))}
                        </Field>
                      </FormControl>
                    </Grid>

                    <Grid xs={12} sm={6} md={2} item>
                      <FormControl margin="dense" variant="outlined" fullWidth>
                        <InputLabel htmlFor="status-selection">
                          {i18n.t("compaies.table.active")}
                        </InputLabel>

                        <Field
                          as={Select}
                          id="status-selection"
                          label={i18n.t("compaies.table.active")}
                          labelId="status-selection-label"
                          name="status"
                          margin="dense"
                        >
                          <MenuItem value={true}>
                            {i18n.t("compaies.table.yes")}
                          </MenuItem>
                          <MenuItem value={false}>
                            {i18n.t("compaies.table.no")}
                          </MenuItem>
                        </Field>
                      </FormControl>
                    </Grid>

                    <Grid xs={12} sm={6} md={2} item>
                      <Field
                        as={TextField}
                        label={i18n.t("compaies.table.dueDate")}
                        type="date"
                        name="dueDate"
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        fullWidth
                        margin="dense"
                      />
                    </Grid>

                    <Grid xs={12} sm={6} md={3} item>
                      <FormControl margin="dense" variant="outlined" fullWidth>
                        <InputLabel htmlFor="recorrencia-selection">
                          {i18n.t("compaies.table.recurrence")}
                        </InputLabel>

                        <Field
                          as={Select}
                          label="Recorrência"
                          labelId="recorrencia-selection-label"
                          id="recurrence"
                          name="recurrence"
                          margin="dense"
                        >
                          <MenuItem value="MENSAL">
                            {i18n.t("compaies.table.monthly")}
                          </MenuItem>
                          <MenuItem value="BIMESTRAL">
                            {i18n.t("compaies.table.bimonthly")}
                          </MenuItem>
                          <MenuItem value="TRIMESTRAL">
                            {i18n.t("compaies.table.quarterly")}
                          </MenuItem>
                          <MenuItem value="SEMESTRAL">
                            {i18n.t("compaies.table.semester")}
                          </MenuItem>
                          <MenuItem value="ANUAL">
                            {i18n.t("compaies.table.yearly")}
                          </MenuItem>
                        </Field>
                      </FormControl>
                    </Grid>

                    <Grid xs={12} sm={6} md={2} item>
                      <FormControl margin="dense" variant="outlined" fullWidth>
                        <InputLabel htmlFor="generate-invoice-selection">
                          Gerar Fatura
                        </InputLabel>

                        <Field
                          as={Select}
                          id="generate-invoice-selection"
                          label="Gerar Fatura"
                          labelId="generate-invoice-selection-label"
                          name="generateInvoice"
                          margin="dense"
                        >
                          <MenuItem value={true}>Sim</MenuItem>
                          <MenuItem value={false}>Não</MenuItem>
                        </Field>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>

              {/* LIBERACOES ADICIONAIS DA EMPRESA */}
              <Grid xs={12} item>
                <Paper
                  variant="outlined"
                  className={classes.sectionPaper}
                >
                  <div className={classes.sectionTitle}>Benefícios adicionais</div>

                  <div className={classes.sectionDescription}>
                    Libere armazenamento ou funcionalidades específicas sem alterar o plano contratado.
                  </div>

                  <Grid container spacing={1}>
                    <Grid xs={12} sm={6} md={2} item>
                      <Field
                        as={TextField}
                        label="Armazenamento extra (GB)"
                        name="storageExtraGB"
                        type="number"
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        inputProps={{ min: 0, step: 1 }}
                      />
                    </Grid>

                    {EXTRA_FEATURES.map((feature) => (
                      <Grid xs={12} sm={6} md={2} item key={feature.key}>
                        <Field name={`featureOverrides.${feature.key}`}>
                          {({ form }) => (
                            <FormControl
                              variant="outlined"
                              margin="dense"
                              fullWidth
                            >
                              <InputLabel
                                id={`extra-${feature.key}-label`}
                              >
                                {feature.label}
                              </InputLabel>

                              <Select
                                labelId={`extra-${feature.key}-label`}
                                label={feature.label}
                                value={
                                  form.values.featureOverrides?.[feature.key] === true
                                    ? "grant"
                                    : "inherit"
                                }
                                onChange={(event) =>
                                  form.setFieldValue(
                                    `featureOverrides.${feature.key}`,
                                    event.target.value === "grant" ? true : null
                                  )
                                }
                              >
                                <MenuItem value="inherit">
                                  Seguir o plano
                                </MenuItem>

                                <MenuItem value="grant">
                                  Liberar adicionalmente
                                </MenuItem>
                              </Select>
                            </FormControl>
                          )}
                        </Field>
                      </Grid>
                    ))}
                  </Grid>
                </Paper>
              </Grid>

              <Grid xs={12} item>
                <Grid justifyContent="flex-end" spacing={1} container>
                  <Grid xs={4} md={1} item>
                    <ButtonWithSpinner
                      className={classes.fullWidth}
                      style={{ marginTop: 7 }}
                      loading={loading}
                      onClick={() => onCancel()}
                      variant="contained"
                    >
                      {i18n.t("compaies.table.clear")}
                    </ButtonWithSpinner>
                  </Grid>
                  {record.id !== undefined ? (
                    <>
                      <Grid xs={6} md={1} item>
                        <ButtonWithSpinner
                          style={{ marginTop: 7 }}
                          className={classes.fullWidth}
                          loading={loading}
                          onClick={() => onDelete(record)}
                          variant="contained"
                          color="secondary"
                          disabled={record.id === 1}
                        >
                          {i18n.t("compaies.table.delete")}
                        </ButtonWithSpinner>
                      </Grid>
                      <Grid xs={6} md={2} item>
                        <ButtonWithSpinner
                          style={{ marginTop: 7 }}
                          className={classes.fullWidth}
                          loading={loading}
                          onClick={() => incrementDueDate()}
                          variant="contained"
                          color="primary"
                        >
                          {i18n.t("compaies.table.dueDate")}
                        </ButtonWithSpinner>
                      </Grid>
                      {/* <Grid xs={6} md={1} item>
                        <ButtonWithSpinner
                          style={{ marginTop: 7 }}
                          className={classes.fullWidth}
                          loading={loading}
                          onClick={() => handleOpenModalUsers()}
                          variant="contained"
                          color="primary"
                        >
                          {i18n.t("compaies.table.user")}
                        </ButtonWithSpinner>
                      </Grid> */}
                    </>
                  ) : null}
                  <Grid xs={6} md={1} item>
                    <ButtonWithSpinner
                      className={classes.fullWidth}
                      style={{ marginTop: 7 }}
                      loading={loading}
                      type="submit"
                      variant="contained"
                      color="primary"
                    >
                      {i18n.t("compaies.table.save")}
                    </ButtonWithSpinner>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </>
  );
}

export function CompaniesManagerGrid(props) {
  const { records, onSelect } = props;
  const classes = useStyles();
  const { dateToClient, datetimeToClient } = useDate();
  const { mode } = useContext(ColorModeContext);
  const theme = useTheme();

  const renderStatus = (row) => {
    return row.status === false ? "Não" : "Sim";
  };

  const renderPlan = (row) => {
    return row?.plan?.name || "-";
  };

  const renderPlanValue = (row) => {
    return row?.plan?.amount
      ? row.plan.amount.toLocaleString("pt-BR", {
          minimumFractionDigits: 2
        })
      : "0,00";
  };

  const formatStorageBytes = (value) => {
    if (value === null || value === undefined) {
      return "Indisponível";
    }

    const bytes = Number(value);

    if (!Number.isFinite(bytes) || bytes < 0) {
      return "Indisponível";
    }

    if (bytes === 0) {
      return "0 MB";
    }

    const gb = bytes / (1024 ** 3);

    if (gb >= 1) {
      return `${gb.toLocaleString("pt-BR", {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
      })} GB`;
    }

    const mb = bytes / (1024 ** 2);

    return `${mb.toLocaleString("pt-BR", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 1
    })} MB`;
  };

  const renderStorage = (row) => {
    const metrics = row?.metrics;
    const quota = row?.storageQuota;

    if (!metrics) {
      return "Calculando...";
    }

    if (metrics.status === "error") {
      return <strong>Indisponível</strong>;
    }

    const conversationBytes =
      metrics.conversationBytes !== undefined &&
      metrics.conversationBytes !== null
        ? metrics.conversationBytes
        : metrics.folderSize;

    const operationalBytes =
      metrics.operationalBytes !== undefined &&
      metrics.operationalBytes !== null
        ? metrics.operationalBytes
        : 0;

    const extraGB = Number(row?.storageExtraGB || 0);

    const usagePercent =
      quota?.usagePercent !== null &&
      quota?.usagePercent !== undefined
        ? Number(quota.usagePercent)
        : null;

    return (
      <>
        <strong>
          {formatStorageBytes(conversationBytes)}
        </strong>

        {quota?.configured ? (
          <span className={classes.secondaryText}>
            Limite: {quota.totalGB} GB
            {usagePercent !== null
              ? ` • Uso: ${usagePercent.toLocaleString("pt-BR", {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 1
                })}%`
              : ""}
          </span>
        ) : (
          <span className={classes.secondaryText}>
            Sem limite configurado
          </span>
        )}

        <span className={classes.secondaryText}>
          Operacional: {formatStorageBytes(operationalBytes)}
          {extraGB > 0 ? ` • Extra: +${extraGB} GB` : ""}
        </span>

        {quota?.exceeded === true ? (
          <span className={classes.secondaryText}>
            <strong>⚠ Acima do limite</strong>
          </span>
        ) : null}
      </>
    );
  };

  // const renderCampaignsStatus = (row) => {
  //   if (
  //     has(row, "settings") &&
  //     isArray(row.settings) &&
  //     row.settings.length > 0
  //   ) {
  //     const setting = row.settings.find((s) => s.key === "campaignsEnabled");
  //     if (setting) {
  //       return setting.value === "true" ? "Habilitadas" : "Desabilitadas";
  //     }
  //   }
  //   return "Desabilitadas";
  // };

  const rowStyle = (record) => {
    if (moment(record.dueDate).isValid()) {
      const now = moment();
      const dueDate = moment(record.dueDate);
      const diff = dueDate.diff(now, "days");
      if (diff >= 1 && diff <= 5) {
        return { backgroundColor: "#fffead" };
      }
      if (diff <= 0) {
        return { backgroundColor: "#fa8c8c" };
      }
    }
    return {};
  };
  
  const cellStyle = (record) => {
    if (moment(record.dueDate).isValid()) {
      const now = moment();
      const dueDate = moment(record.dueDate);
      const diff = dueDate.diff(now, "days");
      if (diff >= 1 && diff <= 5) {
        return { color: "#000" }; // Texto preto para fundo amarelo
      }
      if (diff <= 0) {
        return { color: "#fff" }; // Texto branco para fundo vermelho
      }
    }
    return {};
  };

  const iconStyle = (record) => {
    if (moment(record.dueDate).isValid()) {
      const now = moment();
      const dueDate = moment(record.dueDate);
      const diff = dueDate.diff(now, "days");
      if (diff >= 1 && diff <= 5) {
        return { color: "#000" }; // Ícone preto para fundo amarelo
      }
    }
    return {};
  };

  return (
    <Paper className={classes.tableContainer}>
      <Table
        className={classes.fullWidth}
        // size="small"
        padding="none"
        aria-label="a dense table"
      >
        <TableHead>
          <TableRow>
            <TableCell align="center" style={{ width: 44 }} />

            <TableCell align="left">
              Empresa
            </TableCell>

            <TableCell align="center">
              Plano
            </TableCell>

            <TableCell align="center">
              Status
            </TableCell>

            <TableCell align="center">
              Vencimento
            </TableCell>

            <TableCell align="center">
              Atividade
            </TableCell>

            <TableCell align="center">
              Uso 30 dias
            </TableCell>

            <TableCell align="center">
              Armazenamento
            </TableCell>

            <TableCell align="center">
              Recursos
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {records.map((row, key) => (
            <TableRow style={rowStyle(row)} key={key}>

              <TableCell
                style={cellStyle(row)}
                align="center"
              >
                <IconButton
                  style={iconStyle(row)}
                  onClick={() => onSelect(row)}
                  aria-label="editar"
                  size="small"
                >
                  <EditIcon style={iconStyle(row)} />
                </IconButton>
              </TableCell>

              <TableCell
                style={cellStyle(row)}
                align="left"
              >
                <strong>{row.name || "-"}</strong>

                <span className={classes.secondaryText}>
                  {row.email || "-"}
                </span>

                {row.phone ? (
                  <span className={classes.secondaryText}>
                    {row.phone}
                  </span>
                ) : null}
              </TableCell>

              <TableCell
                style={cellStyle(row)}
                align="center"
              >
                <strong>{renderPlan(row)}</strong>

                <span className={classes.secondaryText}>
                  {i18n.t("compaies.table.money")} {renderPlanValue(row)}
                </span>
              </TableCell>

              <TableCell
                style={cellStyle(row)}
                align="center"
              >
                <strong>
                  {row.status ? "Ativa" : "Inativa"}
                </strong>

                <span className={classes.secondaryText}>
                  {row.generateInvoice
                    ? "Com fatura"
                    : "Sem fatura"}
                </span>

                <span className={classes.secondaryText}>
                  Criada em {dateToClient(row.createdAt)}
                </span>
              </TableCell>

              <TableCell
                style={cellStyle(row)}
                align="center"
              >
                {row.dueDate
                  ? dateToClient(row.dueDate)
                  : "-"}

                {row.recurrence ? (
                  <span className={classes.secondaryText}>
                    {row.recurrence}
                  </span>
                ) : null}
              </TableCell>

              <TableCell
                style={cellStyle(row)}
                align="center"
              >
                {row?.usageMetrics?.lastActivity
                  ? datetimeToClient(
                      row.usageMetrics.lastActivity
                    )
                  : "-"}

                <span className={classes.secondaryText}>
                  Login:{" "}
                  {row.lastLogin
                    ? datetimeToClient(row.lastLogin)
                    : "-"}
                </span>
              </TableCell>

              <TableCell
                style={cellStyle(row)}
                align="center"
              >
                <strong>
                  {row?.usageMetrics?.tickets30d || 0}
                </strong>{" "}
                tickets

                <span className={classes.secondaryText}>
                  {Number(
                    row?.usageMetrics?.messages30d || 0
                  ).toLocaleString("pt-BR")}{" "}
                  msgs
                </span>
              </TableCell>

              <TableCell
                style={cellStyle(row)}
                align="center"
              >
                {renderStorage(row)}
              </TableCell>

              <TableCell
                style={cellStyle(row)}
                align="center"
              >
                Usuários:{" "}
                <strong>
                  {row?.usageMetrics?.usersUsed || 0}
                  {" / "}
                  {row?.plan?.users || 0}
                </strong>

                <span className={classes.secondaryText}>
                  Conexões:{" "}
                  <strong>
                    {row?.usageMetrics?.connectionsQuotaUsed || 0}
                    {" / "}
                    {row?.plan?.connections || 0}
                  </strong>
                </span>
              </TableCell>

            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}

export default function CompaniesManager() {
  const classes = useStyles();
  const { list, save, update, remove } = useCompanies();

  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const [record, setRecord] = useState({
    name: "",
    email: "",
    phone: "",
    planId: "",
    storageExtraGB: 0,
    featureOverrides: {},
    status: true,
    // campaignsEnabled: false,
    dueDate: "",
    recurrence: "",
    password: "",
    document: "",
    paymentMethod: "",
    generateInvoice: true
  });

  useEffect(() => {
    loadPlans();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadPlans = async () => {
    setLoading(true);
    try {
      const companyList = await list();
      console.log("Lista de empresas carregada:", companyList);
      setRecords(companyList);
    } catch (e) {
      toast.error("Não foi possível carregar a lista de registros");
    }
    setLoading(false);
  };

  const handleSubmit = async (data) => {
    console.log("Dados enviados para o backend:", data);
    setLoading(true);
    try {
      if (data.id !== undefined) {
        await update(data);
      } else {
        await save(data);
      }
      await loadPlans();
      handleCancel();
      toast.success("Operação realizada com sucesso!");
    } catch (e) {
      toast.error(
        "Não foi possível realizar a operação. Verifique se já existe uma empresa com o mesmo nome ou se os campos foram preenchidos corretamente"
      );
    }
    setLoading(false);
  };

  const handleGenerateInvoice = async () => {
    if (!record.id || loading) return;
    if (!window.confirm(
      `Emitir uma fatura de assinatura para ${record.name}? ` +
      "O valor sera calculado com base no plano SALVO da empresa. " +
      "Uma fatura aberta existente sera reutilizada."
    )) return;

    setLoading(true);
    try {
      const { data } = await api.post("/admin/invoices/generate", {
        companyId: record.id
      });
      if (data.existing) {
        toast.info(`Ja existe uma fatura em aberto: #${data.invoice.id}.`);
      } else {
        toast.success(`Fatura #${data.invoice.id} emitida. ` +
          "A empresa ja pode acessa-la no Financeiro.");
      }
    } catch (error) {
      toast.error(error.response?.data?.error ||
        "Nao foi possivel emitir a fatura.");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      await remove(record.id);
      await loadPlans();
      handleCancel();
      toast.success("Operação realizada com sucesso!");
    } catch (e) {
      toast.error("Não foi possível realizar a operação");
    }
    setLoading(false);
  };

  const handleOpenDeleteDialog = () => {
    setShowConfirmDialog(true);
  };

  const handleCancel = () => {
    setRecord((prev) => ({
      ...prev,
      name: "",
      email: "",
      phone: "",
      planId: "",
      storageExtraGB: 0,
      featureOverrides: {},
      id: undefined,
      status: true,
      // campaignsEnabled: false,
      dueDate: "",
      recurrence: "",
      password: "",
      document: "",
      paymentMethod: "",
      generateInvoice: true
    }));
  };

  const handleSelect = (data) => {
    // let campaignsEnabled = false;

    // const setting = data.settings.find(
    //   (s) => s.key.indexOf("campaignsEnabled") > -1
    // );
    // if (setting) {
    //   campaignsEnabled = setting.value === "true" || setting.value === "enabled";
    // }

    console.log("Dados da empresa selecionada:", data);
    setRecord((prev) => ({
      ...prev,
      id: data.id,
      name: data.name || "",
      phone: data.phone || "",
      email: data.email || "",
      planId: data.planId || "",
      storageExtraGB: data.storageExtraGB ?? 0,
      featureOverrides: data.featureOverrides || {},
      status: data.status === false ? false : true,
      // campaignsEnabled,
      dueDate: data.dueDate || "",
      recurrence: data.recurrence || "",
      password: "",
      document: data.document || "",
      paymentMethod: data.paymentMethod || "",
      generateInvoice: data.generateInvoice !== undefined ? data.generateInvoice : true,
    }));
  };

  return (
    <Paper className={classes.mainPaper} elevation={0}>
      <Grid spacing={2} container>
        <Grid xs={12} item>
          <CompanyForm
            initialValue={record}
            onDelete={handleOpenDeleteDialog}
            onSubmit={handleSubmit}
            onCancel={handleCancel}
            loading={loading}
          />
        </Grid>
        <Grid xs={12} item>
          {record.id ? (
            <Paper variant="outlined" style={{ padding: 14, marginBottom: 12 }}>
              <strong>Emissao manual de assinatura</strong>
              <div style={{ margin: "7px 0", fontSize: 13 }}>
                Empresa selecionada: {record.name} (#{record.id}).
                O valor e as permissoes sao obtidos do plano salvo,
                sem sobrescrever faturas existentes.
              </div>
              <Button
                variant="contained"
                color="primary"
                disabled={loading}
                onClick={handleGenerateInvoice}
              >
                Gerar fatura
              </Button>
            </Paper>
          ) : null}
          <CompaniesManagerGrid records={records} onSelect={handleSelect} />
        </Grid>
      </Grid>
      <ConfirmationModal
        title="Exclusão de Registro"
        open={showConfirmDialog}
        onClose={() => setShowConfirmDialog(false)}
        onConfirm={() => handleDelete()}
      >
        Deseja realmente excluir esse registro?
      </ConfirmationModal>
    </Paper>
  );
}
